export default __webpack_public_path__ + "static/SR China - HACCP - Certificate-c1d40c2c323e595e43020d242d5b217b.pdf";